import {useEffect, useState} from "react"



export const useDocumentTitle = (title) => {
  const [documentTitle, setDocumentTitle] = useState(title);
  useEffect(() => {
    let str = "Code3 Advisor";
    if (documentTitle && documentTitle !== "")
      str = `Code3 Advisor - ${documentTitle}`;
    document.title = str;
  }, [documentTitle])
  return [documentTitle, setDocumentTitle];
}


export default useDocumentTitle;